import React from 'react';
import BaseProfilingToolMenu from './BaseProfilingToolMenu';

function ProfilingToolMenu() {
    return (
        <BaseProfilingToolMenu
            pathToBeUsed=""
            displayPath=""
        />
    );
}

ProfilingToolMenu.displayName = 'ProfilingToolMenu';

export default ProfilingToolMenu;
